/**
 * @generated SignedSource<<ad78607335e814c6b0670904b971e02f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseVisibility = "MEMBER_ONLY" | "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type cursosQuery$variables = {
  club: string;
};
export type cursosQuery$data = {
  readonly club: {
    readonly coursePage: {
      readonly appearance: {
        readonly backgroundImage: {
          readonly signedUrl: string;
        } | null | undefined;
      };
      readonly categories: ReadonlyArray<{
        readonly courses: ReadonlyArray<{
          readonly canView: boolean;
          readonly visibility: CourseVisibility;
        }>;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"courseCategoryFragment">;
      }>;
    };
    readonly id: string;
  };
};
export type cursosQuery = {
  response: cursosQuery$data;
  variables: cursosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canView",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cursosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CoursePageAppearance",
                "kind": "LinkedField",
                "name": "appearance",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageFile",
                    "kind": "LinkedField",
                    "name": "backgroundImage",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "CourseCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "courses",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": "courses(status:\"ACTIVE\")"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "courseCategoryFragment"
                  }
                ],
                "storageKey": "categories(status:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cursosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CoursePageAppearance",
                "kind": "LinkedField",
                "name": "appearance",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageFile",
                    "kind": "LinkedField",
                    "name": "backgroundImage",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "CourseCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "courses",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageFile",
                        "kind": "LinkedField",
                        "name": "landscapeImage",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageFile",
                        "kind": "LinkedField",
                        "name": "portraitImage",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "completed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "certificateEmission",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentIntegrationProduct",
                        "kind": "LinkedField",
                        "name": "primaryProduct",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "checkoutUrl",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Certificate",
                        "kind": "LinkedField",
                        "name": "certificate",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ObjectFile",
                            "kind": "LinkedField",
                            "name": "file",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "courses(status:\"ACTIVE\")"
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "orientation",
                    "storageKey": null
                  }
                ],
                "storageKey": "categories(status:\"ACTIVE\")"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3cc368d0a00c3daac326724b41e951db",
    "id": null,
    "metadata": {},
    "name": "cursosQuery",
    "operationKind": "query",
    "text": "query cursosQuery(\n  $club: String!\n) {\n  club(slug: $club) {\n    id\n    coursePage {\n      appearance {\n        backgroundImage {\n          signedUrl\n          id\n        }\n      }\n      categories(status: ACTIVE) {\n        id\n        courses(status: ACTIVE) {\n          canView\n          visibility\n          id\n        }\n        ...courseCategoryFragment\n      }\n      id\n    }\n  }\n}\n\nfragment certificateEmitDialogFragment on Course {\n  id\n  name\n}\n\nfragment courseCategoryFragment on CourseCategory {\n  id\n  name\n  orientation\n  courses(status: ACTIVE) {\n    id\n    ...coursePreviewFragment\n  }\n}\n\nfragment coursePreviewFragment on Course {\n  id\n  name\n  slug\n  canView\n  landscapeImage {\n    signedUrl\n    id\n  }\n  portraitImage {\n    signedUrl\n    id\n  }\n  progress\n  completed\n  certificateEmission\n  primaryProduct {\n    enabled\n    checkoutUrl\n    id\n  }\n  certificate {\n    id\n    file {\n      signedUrl\n      id\n    }\n  }\n  ...certificateEmitDialogFragment\n  ...coursePreview_paywall\n}\n\nfragment coursePreview_paywall on Course {\n  visibility\n  primaryProduct {\n    checkoutUrl\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8537e5db9070ebe08d9ce4669d52f8b0";

export default node;
